var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWholeBean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Caf\\xE9s_gr\\xE3os",
    "data-name": "Caf\\xE9s gr\\xE3os",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.43 115.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#343332;}.cls-2{fill:#343333;}.cls-3{fill:#343233;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.58,115.28c2-.32,24.82-4.17,34.42-19.37,9.61-17.48,24.52-18.49,26.64-18.54C127.7,87.66,120,102.85,105,113,88.73,124,69.91,125,62.58,115.28Z",
    transform: "translate(-3.29 -6.06)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.35,109c-3.44-10.28,4.23-25,18.9-34.9,16.27-11,35.07-12,42.41-2.31A36.76,36.76,0,0,0,90.25,91C81,105.65,61.37,108.61,58.35,109Z",
    transform: "translate(-3.29 -6.06)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58,76.2c-1.81-.28-21.87-3.68-30.33-17.07C19.24,43.73,6.1,42.84,4.23,42.79.66,51.86,7.42,65.24,20.66,74.19,35,83.87,51.58,84.73,58,76.2Z",
    transform: "translate(-3.29 -6.06)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.77,70.65c3-9.05-3.73-22-16.65-30.75-14.34-9.69-30.91-10.54-37.38-2A32.44,32.44,0,0,1,33.66,54.78C41.82,67.71,59.1,70.33,61.77,70.65Z",
    transform: "translate(-3.29 -6.06)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.57,57.81c-.24-1.52-2.66-18.48,5.92-28.7C94.67,18.36,92,7.59,91.58,6.09c-8.2-.55-17.2,8.31-21,21.22C66.51,41.3,70.08,54.82,78.57,57.81Z",
    transform: "translate(-3.29 -6.06)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84,59.38c8,.11,16.71-8.64,20.4-21.24,4.09-14,.53-27.5-7.95-30.5a27.32,27.32,0,0,1-6.92,25.13C81.22,42.63,83.56,57.16,84,59.38Z",
    transform: "translate(-3.29 -6.06)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholeBean);
export default __webpack_public_path__ + "static/media/whole-bean.7ee86b3df9307e7accea01385361c3ab.svg";
export { ForwardRef as ReactComponent };